export default function getCommentsFactory(ajax, getSession) {
  return async function getComments(trekId) {
    return ajax('getComments', { id: trekId });
  };
}



// WEBPACK FOOTER //
// ./src/services/getComments.js